export enum CreateWorkStepsEnum {
  preStepWorkType = 'pre_step_work_type',
  generalBase = 'general_base',
  generalSecond = 'general_second',
  jobCoverPhoto = 'cover_photo',
  workSkills = 'work_skills',
  workContact = 'work_contact',
  workShare = 'work_share',
  congratulations = 'congratulations',
}
